// --- Countries (ISO 3166-1 alpha-2) ---
export const COUNTRIES = [
  { value: "AF", label: "Afghanistan" }, { value: "AL", label: "Albania" }, { value: "DZ", label: "Algeria" },
  { value: "AD", label: "Andorra" }, { value: "AO", label: "Angola" }, { value: "AG", label: "Antigua and Barbuda" },
  { value: "AR", label: "Argentina" }, { value: "AM", label: "Armenia" }, { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" }, { value: "AZ", label: "Azerbaijan" }, { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" }, { value: "BD", label: "Bangladesh" }, { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" }, { value: "BE", label: "Belgium" }, { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" }, { value: "BT", label: "Bhutan" }, { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia and Herzegovina" }, { value: "BW", label: "Botswana" }, { value: "BR", label: "Brazil" },
  { value: "BN", label: "Brunei" }, { value: "BG", label: "Bulgaria" }, { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" }, { value: "KH", label: "Cambodia" }, { value: "CM", label: "Cameroon" },
  { value: "CA", label: "Canada" }, { value: "CV", label: "Cape Verde" }, { value: "CF", label: "Central African Republic" },
  { value: "TD", label: "Chad" }, { value: "CL", label: "Chile" }, { value: "CN", label: "China" },
  { value: "CO", label: "Colombia" }, { value: "KM", label: "Comoros" }, { value: "CD", label: "Congo (DRC)" },
  { value: "CG", label: "Congo (Republic)" }, { value: "CR", label: "Costa Rica" }, { value: "CI", label: "Cote d'Ivoire" },
  { value: "HR", label: "Croatia" }, { value: "CU", label: "Cuba" }, { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" }, { value: "DK", label: "Denmark" }, { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" }, { value: "DO", label: "Dominican Republic" }, { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" }, { value: "SV", label: "El Salvador" }, { value: "GQ", label: "Equatorial Guinea" },
  { value: "ER", label: "Eritrea" }, { value: "EE", label: "Estonia" }, { value: "SZ", label: "Eswatini" },
  { value: "ET", label: "Ethiopia" }, { value: "FJ", label: "Fiji" }, { value: "FI", label: "Finland" },
  { value: "FR", label: "France" }, { value: "GA", label: "Gabon" }, { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" }, { value: "DE", label: "Germany" }, { value: "GH", label: "Ghana" },
  { value: "GR", label: "Greece" }, { value: "GD", label: "Grenada" }, { value: "GT", label: "Guatemala" },
  { value: "GN", label: "Guinea" }, { value: "GW", label: "Guinea-Bissau" }, { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" }, { value: "HN", label: "Honduras" }, { value: "HK", label: "Hong Kong" },
  { value: "HU", label: "Hungary" }, { value: "IS", label: "Iceland" }, { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" }, { value: "IR", label: "Iran" }, { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" }, { value: "IL", label: "Israel" }, { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" }, { value: "JP", label: "Japan" }, { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" }, { value: "KE", label: "Kenya" }, { value: "KI", label: "Kiribati" },
  { value: "KR", label: "South Korea" }, { value: "KW", label: "Kuwait" }, { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "Laos" }, { value: "LV", label: "Latvia" }, { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" }, { value: "LR", label: "Liberia" }, { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" }, { value: "LT", label: "Lithuania" }, { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao" }, { value: "MG", label: "Madagascar" }, { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" }, { value: "MV", label: "Maldives" }, { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" }, { value: "MH", label: "Marshall Islands" }, { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" }, { value: "MX", label: "Mexico" }, { value: "FM", label: "Micronesia" },
  { value: "MD", label: "Moldova" }, { value: "MC", label: "Monaco" }, { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" }, { value: "MA", label: "Morocco" }, { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar" }, { value: "NA", label: "Namibia" }, { value: "NR", label: "Nauru" },
  { value: "NP", label: "Nepal" }, { value: "NL", label: "Netherlands" }, { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" }, { value: "NE", label: "Niger" }, { value: "NG", label: "Nigeria" },
  { value: "MK", label: "North Macedonia" }, { value: "NO", label: "Norway" }, { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" }, { value: "PW", label: "Palau" }, { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" }, { value: "PY", label: "Paraguay" }, { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" }, { value: "PL", label: "Poland" }, { value: "PT", label: "Portugal" },
  { value: "QA", label: "Qatar" }, { value: "RO", label: "Romania" }, { value: "RU", label: "Russia" },
  { value: "RW", label: "Rwanda" }, { value: "KN", label: "Saint Kitts and Nevis" }, { value: "LC", label: "Saint Lucia" },
  { value: "VC", label: "Saint Vincent" }, { value: "WS", label: "Samoa" }, { value: "SM", label: "San Marino" },
  { value: "ST", label: "Sao Tome and Principe" }, { value: "SA", label: "Saudi Arabia" }, { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" }, { value: "SC", label: "Seychelles" }, { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" }, { value: "SK", label: "Slovakia" }, { value: "SI", label: "Slovenia" },
  { value: "SB", label: "Solomon Islands" }, { value: "SO", label: "Somalia" }, { value: "ZA", label: "South Africa" },
  { value: "SS", label: "South Sudan" }, { value: "ES", label: "Spain" }, { value: "LK", label: "Sri Lanka" },
  { value: "SD", label: "Sudan" }, { value: "SR", label: "Suriname" }, { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" }, { value: "SY", label: "Syria" }, { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" }, { value: "TZ", label: "Tanzania" }, { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor-Leste" }, { value: "TG", label: "Togo" }, { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trinidad and Tobago" }, { value: "TN", label: "Tunisia" }, { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" }, { value: "TV", label: "Tuvalu" }, { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" }, { value: "AE", label: "United Arab Emirates" }, { value: "GB", label: "United Kingdom" },
  { value: "US", label: "United States" }, { value: "UY", label: "Uruguay" }, { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" }, { value: "VE", label: "Venezuela" }, { value: "VN", label: "Vietnam" },
  { value: "YE", label: "Yemen" }, { value: "ZM", label: "Zambia" }, { value: "ZW", label: "Zimbabwe" },
];

// --- States / Provinces (ISO 3166-2, no country prefix) ---
type StateOption = { value: string; label: string };

const US_STATES: StateOption[] = [
  { value: "AL", label: "Alabama" }, { value: "AK", label: "Alaska" }, { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" }, { value: "CA", label: "California" }, { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" }, { value: "DE", label: "Delaware" }, { value: "DC", label: "District of Columbia" },
  { value: "FL", label: "Florida" }, { value: "GA", label: "Georgia" }, { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" }, { value: "IL", label: "Illinois" }, { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" }, { value: "KS", label: "Kansas" }, { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" }, { value: "ME", label: "Maine" }, { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" }, { value: "MI", label: "Michigan" }, { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" }, { value: "MO", label: "Missouri" }, { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" }, { value: "NV", label: "Nevada" }, { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" }, { value: "NM", label: "New Mexico" }, { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" }, { value: "ND", label: "North Dakota" }, { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" }, { value: "OR", label: "Oregon" }, { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" }, { value: "SC", label: "South Carolina" }, { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" }, { value: "TX", label: "Texas" }, { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" }, { value: "VA", label: "Virginia" }, { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" }, { value: "WI", label: "Wisconsin" }, { value: "WY", label: "Wyoming" },
  { value: "AS", label: "American Samoa" }, { value: "GU", label: "Guam" }, { value: "MP", label: "Northern Mariana Islands" },
  { value: "PR", label: "Puerto Rico" }, { value: "VI", label: "Virgin Islands" },
];

const CA_PROVINCES: StateOption[] = [
  { value: "AB", label: "Alberta" }, { value: "BC", label: "British Columbia" }, { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" }, { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NT", label: "Northwest Territories" }, { value: "NS", label: "Nova Scotia" }, { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" }, { value: "PE", label: "Prince Edward Island" }, { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" }, { value: "YT", label: "Yukon" },
];

const AU_STATES: StateOption[] = [
  { value: "ACT", label: "Australian Capital Territory" }, { value: "NSW", label: "New South Wales" },
  { value: "NT", label: "Northern Territory" }, { value: "QLD", label: "Queensland" },
  { value: "SA", label: "South Australia" }, { value: "TAS", label: "Tasmania" },
  { value: "VIC", label: "Victoria" }, { value: "WA", label: "Western Australia" },
];

const IN_STATES: StateOption[] = [
  { value: "AN", label: "Andaman and Nicobar Islands" }, { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" }, { value: "AS", label: "Assam" }, { value: "BR", label: "Bihar" },
  { value: "CH", label: "Chandigarh" }, { value: "CT", label: "Chhattisgarh" },
  { value: "DH", label: "Dadra and Nagar Haveli and Daman and Diu" }, { value: "DL", label: "Delhi" },
  { value: "GA", label: "Goa" }, { value: "GJ", label: "Gujarat" }, { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" }, { value: "JK", label: "Jammu and Kashmir" },
  { value: "JH", label: "Jharkhand" }, { value: "KA", label: "Karnataka" }, { value: "KL", label: "Kerala" },
  { value: "LA", label: "Ladakh" }, { value: "LD", label: "Lakshadweep" }, { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" }, { value: "MN", label: "Manipur" }, { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" }, { value: "NL", label: "Nagaland" }, { value: "OR", label: "Odisha" },
  { value: "PB", label: "Punjab" }, { value: "PY", label: "Puducherry" }, { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" }, { value: "TN", label: "Tamil Nadu" }, { value: "TG", label: "Telangana" },
  { value: "TR", label: "Tripura" }, { value: "UP", label: "Uttar Pradesh" }, { value: "UT", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
];

const BR_STATES: StateOption[] = [
  { value: "AC", label: "Acre" }, { value: "AL", label: "Alagoas" }, { value: "AP", label: "Amapa" },
  { value: "AM", label: "Amazonas" }, { value: "BA", label: "Bahia" }, { value: "CE", label: "Ceara" },
  { value: "DF", label: "Distrito Federal" }, { value: "ES", label: "Espirito Santo" }, { value: "GO", label: "Goias" },
  { value: "MA", label: "Maranhao" }, { value: "MT", label: "Mato Grosso" }, { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" }, { value: "PA", label: "Para" }, { value: "PB", label: "Paraiba" },
  { value: "PR", label: "Parana" }, { value: "PE", label: "Pernambuco" }, { value: "PI", label: "Piaui" },
  { value: "RJ", label: "Rio de Janeiro" }, { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" }, { value: "RO", label: "Rondonia" }, { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" }, { value: "SP", label: "Sao Paulo" }, { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" },
];

const MX_STATES: StateOption[] = [
  { value: "AGU", label: "Aguascalientes" }, { value: "BCN", label: "Baja California" },
  { value: "BCS", label: "Baja California Sur" }, { value: "CAM", label: "Campeche" },
  { value: "CHP", label: "Chiapas" }, { value: "CHH", label: "Chihuahua" }, { value: "CMX", label: "Ciudad de Mexico" },
  { value: "COA", label: "Coahuila" }, { value: "COL", label: "Colima" }, { value: "DUR", label: "Durango" },
  { value: "GUA", label: "Guanajuato" }, { value: "GRO", label: "Guerrero" }, { value: "HID", label: "Hidalgo" },
  { value: "JAL", label: "Jalisco" }, { value: "MEX", label: "Mexico" }, { value: "MIC", label: "Michoacan" },
  { value: "MOR", label: "Morelos" }, { value: "NAY", label: "Nayarit" }, { value: "NLE", label: "Nuevo Leon" },
  { value: "OAX", label: "Oaxaca" }, { value: "PUE", label: "Puebla" }, { value: "QUE", label: "Queretaro" },
  { value: "ROO", label: "Quintana Roo" }, { value: "SLP", label: "San Luis Potosi" }, { value: "SIN", label: "Sinaloa" },
  { value: "SON", label: "Sonora" }, { value: "TAB", label: "Tabasco" }, { value: "TAM", label: "Tamaulipas" },
  { value: "TLA", label: "Tlaxcala" }, { value: "VER", label: "Veracruz" }, { value: "YUC", label: "Yucatan" },
  { value: "ZAC", label: "Zacatecas" },
];

const JP_PREFECTURES: StateOption[] = [
  { value: "01", label: "Hokkaido" }, { value: "02", label: "Aomori" }, { value: "03", label: "Iwate" },
  { value: "04", label: "Miyagi" }, { value: "05", label: "Akita" }, { value: "06", label: "Yamagata" },
  { value: "07", label: "Fukushima" }, { value: "08", label: "Ibaraki" }, { value: "09", label: "Tochigi" },
  { value: "10", label: "Gunma" }, { value: "11", label: "Saitama" }, { value: "12", label: "Chiba" },
  { value: "13", label: "Tokyo" }, { value: "14", label: "Kanagawa" }, { value: "15", label: "Niigata" },
  { value: "16", label: "Toyama" }, { value: "17", label: "Ishikawa" }, { value: "18", label: "Fukui" },
  { value: "19", label: "Yamanashi" }, { value: "20", label: "Nagano" }, { value: "21", label: "Gifu" },
  { value: "22", label: "Shizuoka" }, { value: "23", label: "Aichi" }, { value: "24", label: "Mie" },
  { value: "25", label: "Shiga" }, { value: "26", label: "Kyoto" }, { value: "27", label: "Osaka" },
  { value: "28", label: "Hyogo" }, { value: "29", label: "Nara" }, { value: "30", label: "Wakayama" },
  { value: "31", label: "Tottori" }, { value: "32", label: "Shimane" }, { value: "33", label: "Okayama" },
  { value: "34", label: "Hiroshima" }, { value: "35", label: "Yamaguchi" }, { value: "36", label: "Tokushima" },
  { value: "37", label: "Kagawa" }, { value: "38", label: "Ehime" }, { value: "39", label: "Kochi" },
  { value: "40", label: "Fukuoka" }, { value: "41", label: "Saga" }, { value: "42", label: "Nagasaki" },
  { value: "43", label: "Kumamoto" }, { value: "44", label: "Oita" }, { value: "45", label: "Miyazaki" },
  { value: "46", label: "Kagoshima" }, { value: "47", label: "Okinawa" },
];

const IT_REGIONS: StateOption[] = [
  { value: "21", label: "Piemonte" }, { value: "23", label: "Valle d'Aosta" }, { value: "25", label: "Lombardia" },
  { value: "32", label: "Trentino-Alto Adige" }, { value: "34", label: "Veneto" },
  { value: "36", label: "Friuli-Venezia Giulia" }, { value: "42", label: "Liguria" },
  { value: "45", label: "Emilia-Romagna" }, { value: "52", label: "Toscana" }, { value: "55", label: "Umbria" },
  { value: "57", label: "Marche" }, { value: "62", label: "Lazio" }, { value: "65", label: "Abruzzo" },
  { value: "67", label: "Molise" }, { value: "72", label: "Campania" }, { value: "75", label: "Puglia" },
  { value: "77", label: "Basilicata" }, { value: "78", label: "Calabria" }, { value: "82", label: "Sicilia" },
  { value: "88", label: "Sardegna" },
];

const ES_REGIONS: StateOption[] = [
  { value: "AN", label: "Andalucia" }, { value: "AR", label: "Aragon" }, { value: "AS", label: "Asturias" },
  { value: "IB", label: "Islas Baleares" }, { value: "PV", label: "Pais Vasco" }, { value: "CN", label: "Canarias" },
  { value: "CB", label: "Cantabria" }, { value: "CL", label: "Castilla y Leon" },
  { value: "CM", label: "Castilla-La Mancha" }, { value: "CT", label: "Cataluna" }, { value: "CE", label: "Ceuta" },
  { value: "EX", label: "Extremadura" }, { value: "GA", label: "Galicia" }, { value: "RI", label: "La Rioja" },
  { value: "MD", label: "Madrid" }, { value: "ML", label: "Melilla" }, { value: "MC", label: "Murcia" },
  { value: "NC", label: "Navarra" }, { value: "VC", label: "Valencia" },
];

const UA_OBLASTS: StateOption[] = [
  { value: "05", label: "Vinnytska oblast" }, { value: "07", label: "Volynska oblast" },
  { value: "09", label: "Luhanska oblast" }, { value: "12", label: "Dnipropetrovska oblast" },
  { value: "14", label: "Donetska oblast" }, { value: "18", label: "Zhytomyrska oblast" },
  { value: "21", label: "Zakarpatska oblast" }, { value: "23", label: "Zaporizka oblast" },
  { value: "26", label: "Ivano-Frankivska oblast" }, { value: "30", label: "Kyiv" },
  { value: "32", label: "Kyivska oblast" }, { value: "35", label: "Kirovohradska oblast" },
  { value: "43", label: "Avtonomna Respublika Krym" }, { value: "46", label: "Lvivska oblast" },
  { value: "48", label: "Mykolaivska oblast" }, { value: "51", label: "Odeska oblast" },
  { value: "53", label: "Poltavska oblast" }, { value: "56", label: "Rivnenska oblast" },
  { value: "59", label: "Sumska oblast" }, { value: "61", label: "Ternopilska oblast" },
  { value: "63", label: "Kharkivska oblast" }, { value: "65", label: "Khersonska oblast" },
  { value: "68", label: "Khmelnytska oblast" }, { value: "71", label: "Cherkaska oblast" },
  { value: "74", label: "Chernihivska oblast" }, { value: "77", label: "Chernivetska oblast" },
];

const CN_PROVINCES: StateOption[] = [
  { value: "11", label: "Beijing" }, { value: "12", label: "Tianjin" }, { value: "13", label: "Hebei" },
  { value: "14", label: "Shanxi" }, { value: "15", label: "Nei Mongol" }, { value: "21", label: "Liaoning" },
  { value: "22", label: "Jilin" }, { value: "23", label: "Heilongjiang" }, { value: "31", label: "Shanghai" },
  { value: "32", label: "Jiangsu" }, { value: "33", label: "Zhejiang" }, { value: "34", label: "Anhui" },
  { value: "35", label: "Fujian" }, { value: "36", label: "Jiangxi" }, { value: "37", label: "Shandong" },
  { value: "41", label: "Henan" }, { value: "42", label: "Hubei" }, { value: "43", label: "Hunan" },
  { value: "44", label: "Guangdong" }, { value: "45", label: "Guangxi" }, { value: "46", label: "Hainan" },
  { value: "50", label: "Chongqing" }, { value: "51", label: "Sichuan" }, { value: "52", label: "Guizhou" },
  { value: "53", label: "Yunnan" }, { value: "54", label: "Xizang" }, { value: "61", label: "Shaanxi" },
  { value: "62", label: "Gansu" }, { value: "63", label: "Qinghai" }, { value: "64", label: "Ningxia" },
  { value: "65", label: "Xinjiang" }, { value: "71", label: "Taiwan" }, { value: "91", label: "Hong Kong" },
  { value: "92", label: "Macao" },
];

const KR_PROVINCES: StateOption[] = [
  { value: "11", label: "Seoul" }, { value: "26", label: "Busan" }, { value: "27", label: "Daegu" },
  { value: "28", label: "Incheon" }, { value: "29", label: "Gwangju" }, { value: "30", label: "Daejeon" },
  { value: "31", label: "Ulsan" }, { value: "36", label: "Sejong" }, { value: "41", label: "Gyeonggi" },
  { value: "42", label: "Gangwon" }, { value: "43", label: "Chungbuk" }, { value: "44", label: "Chungnam" },
  { value: "45", label: "Jeonbuk" }, { value: "46", label: "Jeonnam" }, { value: "47", label: "Gyeongbuk" },
  { value: "48", label: "Gyeongnam" }, { value: "49", label: "Jeju" },
];

const TH_PROVINCES: StateOption[] = [
  { value: "10", label: "Bangkok" }, { value: "11", label: "Samut Prakan" }, { value: "12", label: "Nonthaburi" },
  { value: "13", label: "Pathum Thani" }, { value: "14", label: "Phra Nakhon Si Ayutthaya" },
  { value: "15", label: "Ang Thong" }, { value: "16", label: "Lop Buri" }, { value: "17", label: "Sing Buri" },
  { value: "18", label: "Chai Nat" }, { value: "19", label: "Saraburi" }, { value: "20", label: "Chon Buri" },
  { value: "21", label: "Rayong" }, { value: "22", label: "Chanthaburi" }, { value: "23", label: "Trat" },
  { value: "24", label: "Chachoengsao" }, { value: "25", label: "Prachin Buri" },
  { value: "26", label: "Nakhon Nayok" }, { value: "27", label: "Sa Kaeo" },
  { value: "30", label: "Nakhon Ratchasima" }, { value: "31", label: "Buri Ram" },
  { value: "32", label: "Surin" }, { value: "33", label: "Si Sa Ket" }, { value: "34", label: "Ubon Ratchathani" },
  { value: "35", label: "Yasothon" }, { value: "36", label: "Chaiyaphum" },
  { value: "37", label: "Amnat Charoen" }, { value: "38", label: "Bueng Kan" },
  { value: "39", label: "Nong Bua Lam Phu" }, { value: "40", label: "Khon Kaen" },
  { value: "41", label: "Udon Thani" }, { value: "42", label: "Loei" }, { value: "43", label: "Nong Khai" },
  { value: "44", label: "Maha Sarakham" }, { value: "45", label: "Roi Et" },
  { value: "46", label: "Kalasin" }, { value: "47", label: "Sakon Nakhon" },
  { value: "48", label: "Nakhon Phanom" }, { value: "49", label: "Mukdahan" },
  { value: "50", label: "Chiang Mai" }, { value: "51", label: "Lamphun" }, { value: "52", label: "Lampang" },
  { value: "53", label: "Uttaradit" }, { value: "54", label: "Phrae" }, { value: "55", label: "Nan" },
  { value: "56", label: "Phayao" }, { value: "57", label: "Chiang Rai" },
  { value: "58", label: "Mae Hong Son" }, { value: "60", label: "Nakhon Sawan" },
  { value: "61", label: "Uthai Thani" }, { value: "62", label: "Kamphaeng Phet" },
  { value: "63", label: "Tak" }, { value: "64", label: "Sukhothai" }, { value: "65", label: "Phitsanulok" },
  { value: "66", label: "Phichit" }, { value: "67", label: "Phetchabun" },
  { value: "70", label: "Ratchaburi" }, { value: "71", label: "Kanchanaburi" },
  { value: "72", label: "Suphan Buri" }, { value: "73", label: "Nakhon Pathom" },
  { value: "74", label: "Samut Sakhon" }, { value: "75", label: "Samut Songkhram" },
  { value: "76", label: "Phetchaburi" }, { value: "77", label: "Prachuap Khiri Khan" },
  { value: "80", label: "Nakhon Si Thammarat" }, { value: "81", label: "Krabi" },
  { value: "82", label: "Phangnga" }, { value: "83", label: "Phuket" },
  { value: "84", label: "Surat Thani" }, { value: "85", label: "Ranong" },
  { value: "86", label: "Chumphon" }, { value: "90", label: "Songkhla" }, { value: "91", label: "Satun" },
  { value: "92", label: "Trang" }, { value: "93", label: "Phatthalung" }, { value: "94", label: "Pattani" },
  { value: "95", label: "Yala" }, { value: "96", label: "Narathiwat" },
];

const ID_PROVINCES: StateOption[] = [
  { value: "AC", label: "Aceh" }, { value: "BA", label: "Bali" }, { value: "BB", label: "Bangka Belitung" },
  { value: "BT", label: "Banten" }, { value: "BE", label: "Bengkulu" }, { value: "GO", label: "Gorontalo" },
  { value: "JK", label: "Jakarta" }, { value: "JA", label: "Jambi" }, { value: "JB", label: "Jawa Barat" },
  { value: "JT", label: "Jawa Tengah" }, { value: "JI", label: "Jawa Timur" },
  { value: "KB", label: "Kalimantan Barat" }, { value: "KS", label: "Kalimantan Selatan" },
  { value: "KT", label: "Kalimantan Tengah" }, { value: "KI", label: "Kalimantan Timur" },
  { value: "KU", label: "Kalimantan Utara" }, { value: "KR", label: "Kepulauan Riau" },
  { value: "LA", label: "Lampung" }, { value: "MA", label: "Maluku" }, { value: "MU", label: "Maluku Utara" },
  { value: "NB", label: "Nusa Tenggara Barat" }, { value: "NT", label: "Nusa Tenggara Timur" },
  { value: "PA", label: "Papua" }, { value: "PB", label: "Papua Barat" }, { value: "RI", label: "Riau" },
  { value: "SR", label: "Sulawesi Barat" }, { value: "SN", label: "Sulawesi Selatan" },
  { value: "ST", label: "Sulawesi Tengah" }, { value: "SG", label: "Sulawesi Tenggara" },
  { value: "SA", label: "Sulawesi Utara" }, { value: "SB", label: "Sumatera Barat" },
  { value: "SS", label: "Sumatera Selatan" }, { value: "SU", label: "Sumatera Utara" },
  { value: "YO", label: "Yogyakarta" },
];

const MY_STATES: StateOption[] = [
  { value: "01", label: "Johor" }, { value: "02", label: "Kedah" }, { value: "03", label: "Kelantan" },
  { value: "04", label: "Melaka" }, { value: "05", label: "Negeri Sembilan" }, { value: "06", label: "Pahang" },
  { value: "07", label: "Pulau Pinang" }, { value: "08", label: "Perak" }, { value: "09", label: "Perlis" },
  { value: "10", label: "Selangor" }, { value: "11", label: "Terengganu" }, { value: "12", label: "Sabah" },
  { value: "13", label: "Sarawak" }, { value: "14", label: "Kuala Lumpur" }, { value: "15", label: "Labuan" },
  { value: "16", label: "Putrajaya" },
];

const NZ_REGIONS: StateOption[] = [
  { value: "AUK", label: "Auckland" }, { value: "BOP", label: "Bay of Plenty" },
  { value: "CAN", label: "Canterbury" }, { value: "GIS", label: "Gisborne" },
  { value: "HKB", label: "Hawke's Bay" }, { value: "MWT", label: "Manawatu-Wanganui" },
  { value: "MBH", label: "Marlborough" }, { value: "NSN", label: "Nelson" },
  { value: "NTL", label: "Northland" }, { value: "OTA", label: "Otago" },
  { value: "STL", label: "Southland" }, { value: "TKI", label: "Taranaki" },
  { value: "TAS", label: "Tasman" }, { value: "WKO", label: "Waikato" },
  { value: "WGN", label: "Wellington" }, { value: "WTC", label: "West Coast" },
];

const ZA_PROVINCES: StateOption[] = [
  { value: "EC", label: "Eastern Cape" }, { value: "FS", label: "Free State" },
  { value: "GP", label: "Gauteng" }, { value: "KZN", label: "KwaZulu-Natal" },
  { value: "LP", label: "Limpopo" }, { value: "MP", label: "Mpumalanga" },
  { value: "NC", label: "Northern Cape" }, { value: "NW", label: "North West" },
  { value: "WC", label: "Western Cape" },
];

const NG_STATES: StateOption[] = [
  { value: "AB", label: "Abia" }, { value: "AD", label: "Adamawa" }, { value: "AK", label: "Akwa Ibom" },
  { value: "AN", label: "Anambra" }, { value: "BA", label: "Bauchi" }, { value: "BY", label: "Bayelsa" },
  { value: "BE", label: "Benue" }, { value: "BO", label: "Borno" }, { value: "CR", label: "Cross River" },
  { value: "DE", label: "Delta" }, { value: "EB", label: "Ebonyi" }, { value: "ED", label: "Edo" },
  { value: "EK", label: "Ekiti" }, { value: "EN", label: "Enugu" }, { value: "FC", label: "Federal Capital Territory" },
  { value: "GO", label: "Gombe" }, { value: "IM", label: "Imo" }, { value: "JI", label: "Jigawa" },
  { value: "KD", label: "Kaduna" }, { value: "KN", label: "Kano" }, { value: "KT", label: "Katsina" },
  { value: "KE", label: "Kebbi" }, { value: "KO", label: "Kogi" }, { value: "KW", label: "Kwara" },
  { value: "LA", label: "Lagos" }, { value: "NA", label: "Nasarawa" }, { value: "NI", label: "Niger" },
  { value: "OG", label: "Ogun" }, { value: "ON", label: "Ondo" }, { value: "OS", label: "Osun" },
  { value: "OY", label: "Oyo" }, { value: "PL", label: "Plateau" }, { value: "RI", label: "Rivers" },
  { value: "SO", label: "Sokoto" }, { value: "TA", label: "Taraba" }, { value: "YO", label: "Yobe" },
  { value: "ZA", label: "Zamfara" },
];

// Map: country code → { options, label }
export const STATES: Record<string, { options: StateOption[]; label: string }> = {
  US: { options: US_STATES, label: "State" },
  CA: { options: CA_PROVINCES, label: "Province" },
  AU: { options: AU_STATES, label: "State" },
  IN: { options: IN_STATES, label: "State" },
  BR: { options: BR_STATES, label: "State" },
  MX: { options: MX_STATES, label: "State" },
  JP: { options: JP_PREFECTURES, label: "Prefecture" },
  IT: { options: IT_REGIONS, label: "Region" },
  ES: { options: ES_REGIONS, label: "Region" },
  UA: { options: UA_OBLASTS, label: "Oblast" },
  CN: { options: CN_PROVINCES, label: "Province" },
  KR: { options: KR_PROVINCES, label: "Province" },
  TH: { options: TH_PROVINCES, label: "Province" },
  ID: { options: ID_PROVINCES, label: "Province" },
  MY: { options: MY_STATES, label: "State" },
  NZ: { options: NZ_REGIONS, label: "Region" },
  ZA: { options: ZA_PROVINCES, label: "Province" },
  NG: { options: NG_STATES, label: "State" },
};

// --- Postal code patterns ---
export const POSTAL_PATTERNS: Record<string, RegExp> = {
  // Americas
  US: /^\d{5}(-\d{4})?$/,
  CA: /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i,
  BR: /^\d{5}-?\d{3}$/,
  MX: /^\d{5}$/,
  AR: /^[A-Z]\d{4}[A-Z]{3}$/i,
  CL: /^\d{7}$/,
  CO: /^\d{6}$/,
  // Europe — Western
  GB: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i,
  DE: /^\d{5}$/,
  FR: /^\d{5}$/,
  IT: /^\d{5}$/,
  ES: /^\d{5}$/,
  NL: /^\d{4}\s?[A-Z]{2}$/i,
  BE: /^\d{4}$/,
  AT: /^\d{4}$/,
  CH: /^\d{4}$/,
  PT: /^\d{4}-?\d{3}$/,
  IE: /^[A-Z\d]{3}\s?[A-Z\d]{4}$/i,
  LU: /^\d{4}$/,
  // Europe — Nordic
  SE: /^\d{3}\s?\d{2}$/,
  NO: /^\d{4}$/,
  DK: /^\d{4}$/,
  FI: /^\d{5}$/,
  IS: /^\d{3}$/,
  // Europe — Central & Eastern
  PL: /^\d{2}-?\d{3}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  SK: /^\d{3}\s?\d{2}$/,
  HU: /^\d{4}$/,
  RO: /^\d{6}$/,
  BG: /^\d{4}$/,
  HR: /^\d{5}$/,
  SI: /^\d{4}$/,
  // Europe — Baltic & Eastern
  EE: /^\d{5}$/,
  LT: /^LT-?\d{5}$/i,
  LV: /^LV-?\d{4}$/i,
  UA: /^\d{5}$/,
  // Europe — Southern & Other
  GR: /^\d{3}\s?\d{2}$/,
  TR: /^\d{5}$/,
  CY: /^\d{4}$/,
  MT: /^[A-Z]{3}\s?\d{4}$/i,
  // Asia-Pacific
  JP: /^\d{3}-?\d{4}$/,
  IN: /^\d{6}$/,
  AU: /^\d{4}$/,
  NZ: /^\d{4}$/,
  KR: /^\d{5}$/,
  SG: /^\d{6}$/,
  TW: /^\d{3,5}$/,
  TH: /^\d{5}$/,
  MY: /^\d{5}$/,
  ID: /^\d{5}$/,
  PH: /^\d{4}$/,
  CN: /^\d{6}$/,
  HK: /^$/,  // Hong Kong has no postal codes
  // Middle East
  IL: /^\d{7}$/,
  AE: /^$/,  // UAE has no postal codes
  SA: /^\d{5}(-\d{4})?$/,
  // Africa
  ZA: /^\d{4}$/,
  NG: /^\d{6}$/,
};

export const getCountryLabel = (code: string) =>
  COUNTRIES.find((c) => c.value === code)?.label || code;

export const getStateLabel = (code: string, country: string) => {
  const states = STATES[country];
  if (!states) return code;
  return states.options.find((s) => s.value === code)?.label || code;
};

// Max length + allowed chars per country for input filtering
export const POSTAL_INPUT_RULES: Record<string, { maxLength: number; allow: RegExp }> = {
  // digits only
  US: { maxLength: 10, allow: /[\d-]/ },
  DE: { maxLength: 5, allow: /\d/ },
  FR: { maxLength: 5, allow: /\d/ },
  IT: { maxLength: 5, allow: /\d/ },
  ES: { maxLength: 5, allow: /\d/ },
  AU: { maxLength: 4, allow: /\d/ },
  NZ: { maxLength: 4, allow: /\d/ },
  IN: { maxLength: 6, allow: /\d/ },
  JP: { maxLength: 8, allow: /[\d-]/ },
  KR: { maxLength: 5, allow: /\d/ },
  SG: { maxLength: 6, allow: /\d/ },
  CN: { maxLength: 6, allow: /\d/ },
  TW: { maxLength: 5, allow: /\d/ },
  TH: { maxLength: 5, allow: /\d/ },
  MY: { maxLength: 5, allow: /\d/ },
  ID: { maxLength: 5, allow: /\d/ },
  PH: { maxLength: 4, allow: /\d/ },
  UA: { maxLength: 5, allow: /\d/ },
  RO: { maxLength: 6, allow: /\d/ },
  BG: { maxLength: 4, allow: /\d/ },
  HU: { maxLength: 4, allow: /\d/ },
  TR: { maxLength: 5, allow: /\d/ },
  CY: { maxLength: 4, allow: /\d/ },
  IL: { maxLength: 7, allow: /\d/ },
  ZA: { maxLength: 4, allow: /\d/ },
  NG: { maxLength: 6, allow: /\d/ },
  NO: { maxLength: 4, allow: /\d/ },
  DK: { maxLength: 4, allow: /\d/ },
  FI: { maxLength: 5, allow: /\d/ },
  IS: { maxLength: 3, allow: /\d/ },
  SE: { maxLength: 6, allow: /[\d ]/ },
  CH: { maxLength: 4, allow: /\d/ },
  AT: { maxLength: 4, allow: /\d/ },
  BE: { maxLength: 4, allow: /\d/ },
  LU: { maxLength: 4, allow: /\d/ },
  HR: { maxLength: 5, allow: /\d/ },
  SI: { maxLength: 4, allow: /\d/ },
  MX: { maxLength: 5, allow: /\d/ },
  CO: { maxLength: 6, allow: /\d/ },
  CL: { maxLength: 7, allow: /\d/ },
  EE: { maxLength: 5, allow: /\d/ },
  SA: { maxLength: 10, allow: /[\d-]/ },
  // digits + dashes
  BR: { maxLength: 9, allow: /[\d-]/ },
  PL: { maxLength: 6, allow: /[\d-]/ },
  CZ: { maxLength: 6, allow: /[\d ]/ },
  SK: { maxLength: 6, allow: /[\d ]/ },
  GR: { maxLength: 6, allow: /[\d ]/ },
  PT: { maxLength: 8, allow: /[\d-]/ },
  // letters + digits
  GB: { maxLength: 8, allow: /[A-Za-z\d ]/ },
  CA: { maxLength: 7, allow: /[A-Za-z\d ]/ },
  NL: { maxLength: 7, allow: /[A-Za-z\d ]/ },
  IE: { maxLength: 8, allow: /[A-Za-z\d ]/ },
  MT: { maxLength: 8, allow: /[A-Za-z\d ]/ },
  AR: { maxLength: 8, allow: /[A-Za-z\d]/ },
  LT: { maxLength: 8, allow: /[A-Za-z\d-]/ },
  LV: { maxLength: 7, allow: /[A-Za-z\d-]/ },
};

export const filterPostalInput = (value: string, country: string): string => {
  const rules = POSTAL_INPUT_RULES[country];
  if (!rules) return value.slice(0, 10); // fallback max 10 chars
  const filtered = value.split("").filter((ch) => rules.allow.test(ch)).join("");
  return filtered.slice(0, rules.maxLength);
};

export const validatePostalCode = (code: string, country: string): string | null => {
  if (!code.trim()) return null;
  const pattern = POSTAL_PATTERNS[country];
  if (!pattern) return null;
  if (pattern.source === "^$") return null;
  if (!pattern.test(code.trim())) {
    return `Invalid postal code format for ${getCountryLabel(country)}`;
  }
  return null;
};
